import { getAuthAxiosBackend } from "@/helpers/axios"
import { SacrificerServices } from "@/services/sacrificerServices"

class WoundedServices extends SacrificerServices{

    getProfileDataByPersonId(id){
        return getAuthAxiosBackend().get('PersonProfile/woundedProfile/' + id.toString())
    }
}

export default new WoundedServices()